import { incYenOf } from '../../../lib/pricing';
const corporateAutomotive = {
  // HeroSection
  'corporateAutomotive.hero.homeLink': 'ホーム',
  'corporateAutomotive.hero.corporateLink': '法人研修',
  'corporateAutomotive.hero.currentPage': '自動車・モビリティ向け',
  'corporateAutomotive.hero.title': '自動車・モビリティ向け 法人研修',
  'corporateAutomotive.hero.titleEn': 'FOR AUTOMOTIVE & MOBILITY',
  'corporateAutomotive.hero.lead': 'ブランド体験の質を、日本の執事学校による執事の所作に基づくビジネスマナー研修で高めるプログラムです。',
  'corporateAutomotive.hero.cta': 'この業種で相談する',
  'corporateAutomotive.hero.imgAlt': 'ブランド体験施設で来場者を出迎える日本人スタッフ',
  'corporateAutomotive.hero.badge1': 'ブランド体験・イベント接遇の型を確立',
  'corporateAutomotive.hero.badge2': '出張型で貴社の現場に合わせた訓練',
  'corporateAutomotive.hero.badge3': '執事養成課程と同一の講師陣',

  // PainPoints
  'corporateAutomotive.pain.label': 'CHALLENGES',
  'corporateAutomotive.pain.title': 'こんな課題をお持ちではありませんか',
  'corporateAutomotive.pain.titleEn': 'Common Challenges',
  'corporateAutomotive.pain.lead': 'ブランド体験の質は、車両の魅力だけでは決まりません。来場者を迎える所作、場を整える段取り、VIPを案内する動線に、接遇の格が表れます。',
  'corporateAutomotive.pain.0': 'ブランド体験施設・ショールームの「もてなし」がブランドの世界観に追いついていない',
  'corporateAutomotive.pain.1': 'メーカー主催の試乗会・発表会・オーナーズイベントの接遇を統一したい',
  'corporateAutomotive.pain.2': '株主・VIP・メディアの来場対応に自信がない',
  'corporateAutomotive.pain.3': '販売店スタッフへ展開できる接遇の型がない',

  // WhyButlerWorks
  'corporateAutomotive.why.label': 'WHY BUTLER METHOD',
  'corporateAutomotive.why.title': 'なぜ執事の作法がブランド体験に効くのか？',
  'corporateAutomotive.why.titleEn': 'Why the Butler Approach Works',
  'corporateAutomotive.why.lead1': '来賓を迎え、場を整え、滞りのない時間を設計する執事の技術は、ブランド体験施設での接遇とそのまま重なります。',
  'corporateAutomotive.why.lead2': '本研修が提供するのは、プロの執事が培ったもてなしの型を、貴社のブランド現場で使えるビジネスマナーとして移植することです。',
  'corporateAutomotive.why.0.title': '来賓を迎え、場を整え、満足を設計する技術',
  'corporateAutomotive.why.0.desc': '執事は、ひとりの主を迎えるために所作を磨き、場を整え、滞りのない時間を設計する技術を何世代にもわたって体系化してきました。この「もてなしの型」は、ブランド体験施設やイベントで来場者を迎える現場にそのまま応用できます。',
  'corporateAutomotive.why.1.title': 'ブランド体験と重なる所作',
  'corporateAutomotive.why.1.desc': 'お出迎えの第一声、ご案内の動線、車両前での立ち位置と説明の所作——これらはすべて、執事が来賓を迎えるときの所作と重なります。本研修では、ブランドの世界観を「所作」で体現する技術をお伝えします。',
  'corporateAutomotive.why.2.title': '座学ではなく実技で型を渡す',
  'corporateAutomotive.why.2.desc': '座学で概念を学ぶだけでは、現場で再現できません。本研修は実技中心で構成し、受講者の身体に型を覚えさせることで、研修翌日から現場で使える品質を目指します。また、型を言語化してお渡しするため、社内での自主訓練や点検基準としてもご活用いただけます。',

  // RecommendedPrograms
  'corporateAutomotive.rec.label': 'RECOMMENDED',
  'corporateAutomotive.rec.title': '推奨プログラム構成',
  'corporateAutomotive.rec.titleEn': 'Program Examples for Automotive & Mobility',
  'corporateAutomotive.rec.lead': '貴社の施設・イベントに合わせて、最適な研修構成をご提案します。',
  'corporateAutomotive.rec.badge': '標準',
  'corporateAutomotive.rec.priceSuffix': '円（税込）',
  'corporateAutomotive.rec.corporateLink': '法人研修総合ページ',
  'corporateAutomotive.rec.corporateLinkText': 'モジュールの詳細は',
  'corporateAutomotive.rec.corporateLinkSuffix': 'をご覧ください。',
  'corporateAutomotive.rec.0.duration': '3時間',
  'corporateAutomotive.rec.0.price': incYenOf('ct-single-halfday'),
  'corporateAutomotive.rec.0.modules': 'M1（立ち居振る舞い）＋ M3（おもてなし・ご案内実技）',
  'corporateAutomotive.rec.0.description': 'ブランド体験施設の現場ですぐ使える立ち居振る舞いとご案内の型に集中する短期プランです。まずは試行的に導入したい場合や、特定の課題に絞ったブラッシュアップに適しています。',
  'corporateAutomotive.rec.1.duration': '6時間',
  'corporateAutomotive.rec.1.price': incYenOf('ct-single-fullday'),
  'corporateAutomotive.rec.1.modules': 'M1 ＋ M2（VIP・来賓対応の原則）＋ M3 ＋ M4（イベント想定ロールプレイング）',
  'corporateAutomotive.rec.1.description': '立ち居振る舞いからVIP・来賓対応の原則、イベントを想定したロールプレイングまで、ブランド体験の接遇基盤を1日で網羅する推奨プランです。',
  'corporateAutomotive.rec.2.duration': '1〜2日（応相談）',
  'corporateAutomotive.rec.2.price': `${incYenOf('ct-single-fullday')}〜${incYenOf('ct-single-2day')}`,
  'corporateAutomotive.rec.2.modules': '発表会・試乗会の運営に合わせた通し稽古',
  'corporateAutomotive.rec.2.description': '発表会や試乗会の日程に合わせ、受付からお見送りまでの全動線を通し稽古する集中プランです。イベントの運営マニュアルを事前にお預かりし、貴社の流れに沿った実技訓練を設計します。',

  // ScenarioTraining
  'corporateAutomotive.scenario.label': 'SCENARIOS',
  'corporateAutomotive.scenario.title': '自動車・モビリティ特化の演習シナリオ',
  'corporateAutomotive.scenario.titleEn': 'Automotive Training Scenarios',
  'corporateAutomotive.scenario.lead': '研修はブランド体験施設・イベント現場の実際の場面を再現して行います。代表的なシナリオを三つご紹介します。',
  'corporateAutomotive.scenario.note': '※シナリオは貴社の施設・イベントに合わせて調整できます。',
  'corporateAutomotive.scenario.0.title': 'ブランド体験施設での来場対応',
  'corporateAutomotive.scenario.0.desc': 'お出迎えの第一声から、ご案内動線での距離感と歩調、車両前でのご説明時の立ち位置と所作、質疑応答での姿勢と目線の配り方まで、ブランド体験施設での一連の接遇を反復練習します。特に来場者が最初に感じる「迎え入れの質」に重点を置き、施設の世界観を所作で体現する技術を習得します。',
  'corporateAutomotive.scenario.1.title': '試乗会・オーナーズイベント',
  'corporateAutomotive.scenario.1.desc': '受付での第一印象から、待ち時間の気配り、試乗前のご案内、ご家族・同伴者への配慮、お見送りまで、イベントの全接点を通し稽古します。イベントでは来場者の属性や期待値が多様であるため、状況に応じた対応の引き出しを増やす訓練を行います。',
  'corporateAutomotive.scenario.2.title': '株主・VIP・メディアの来場対応',
  'corporateAutomotive.scenario.2.desc': '席次の考え方、正しい呼称と紹介の作法、写真撮影時の立ち位置と配慮、オフレコ対応の線引きなど、格式が求められる場での対応をロールプレイングで訓練します。単なるマニュアル対応ではなく、相手の立場に立った「先回りの気配り」を体得します。',

  // TargetRoles
  'corporateAutomotive.target.label': 'TARGET',
  'corporateAutomotive.target.title': '対象職種・推奨人数',
  'corporateAutomotive.target.titleEn': 'Target Roles & Capacity',
  'corporateAutomotive.target.lead': 'ブランド体験施設スタッフからイベント運営担当まで、来場者と直接接するすべての職種の皆様にご受講いただけます。',
  'corporateAutomotive.target.capacity': '推奨12名まで',
  'corporateAutomotive.target.capacityNote': '超過する場合は2班制等をご提案します。出張型でブランド体験施設・会場にて実施します。',
  'corporateAutomotive.target.role0': 'ブランド体験施設スタッフ',
  'corporateAutomotive.target.role1': 'イベント運営担当',
  'corporateAutomotive.target.role2': '広報・顧客リレーション',
  'corporateAutomotive.target.role3': '受付・ホスピタリティ担当',
  'corporateAutomotive.target.role4': '販売店指導担当',

  // PricingTable
  'corporateAutomotive.pricing.label': 'PRICING',
  'corporateAutomotive.pricing.title': '料金プラン',
  'corporateAutomotive.pricing.titleEn': 'Transparent Pricing',
  'corporateAutomotive.pricing.lead': 'すべて税込価格での明確な料金体系です。貴社のご予算と目標に合わせて最適なプランをお選びいただけます。',
  'corporateAutomotive.pricing.colPlan': 'プラン',
  'corporateAutomotive.pricing.colDuration': '時間',
  'corporateAutomotive.pricing.colPrice': '料金（税込）',
  'corporateAutomotive.pricing.colNote': '内容',
  'corporateAutomotive.pricing.badge': '標準',
  'corporateAutomotive.pricing.priceSuffix': '円',
  'corporateAutomotive.pricing.conditionsTitle': '共通条件',
  'corporateAutomotive.pricing.corporateLinkText': '継続プログラム・覆面サービス診断などの全メニューは',
  'corporateAutomotive.pricing.corporateLink': '法人研修総合ページ',
  'corporateAutomotive.pricing.corporateLinkSuffix': 'をご覧ください。',
  'corporateAutomotive.pricing.cta': '研修について問い合わせる',
  'corporateAutomotive.pricing.plan0.name': '半日プラン',
  'corporateAutomotive.pricing.plan0.duration': '3時間',
  'corporateAutomotive.pricing.plan0.note': '2モジュール選択',
  'corporateAutomotive.pricing.plan1.name': '1日プラン',
  'corporateAutomotive.pricing.plan1.duration': '6時間',
  'corporateAutomotive.pricing.plan1.note': '4モジュール選択',
  'corporateAutomotive.pricing.plan2.name': '2日間パッケージ',
  'corporateAutomotive.pricing.plan2.duration': '12時間（2日間）',
  'corporateAutomotive.pricing.plan2.note': '全6モジュール受講可',
  'corporateAutomotive.pricing.cond.dispatch': '出張時の交通費・宿泊費は実費別途',
  'corporateAutomotive.pricing.cond.capacity': '推奨12名まで（超過は2班制等をご提案）',
  'corporateAutomotive.pricing.cond.payment': 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  'corporateAutomotive.pricing.cond.cancel': 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',

  // FlowSteps
  'corporateAutomotive.flow.label': 'FLOW',
  'corporateAutomotive.flow.title': 'ご利用の流れ',
  'corporateAutomotive.flow.titleEn': 'From Inquiry to Results',
  'corporateAutomotive.flow.lead': 'お問い合わせから実施後レポートまで、5つのステップで進めます。イベント日程に合わせた集中実施にも対応します。',
  'corporateAutomotive.flow.step0.title': 'お問い合わせ',
  'corporateAutomotive.flow.step0.desc': 'フォームまたはお電話・メールにてご連絡ください。',
  'corporateAutomotive.flow.step1.title': 'ヒアリング',
  'corporateAutomotive.flow.step1.desc': '対象人数・課題・希望時期・イベント予定などをオンラインまたはお電話で伺います。',
  'corporateAutomotive.flow.step2.title': '提案・お見積り',
  'corporateAutomotive.flow.step2.desc': 'ヒアリング内容をもとに、貴社の施設・イベントに最適な研修プログラムとお見積りをご提案します。',
  'corporateAutomotive.flow.step3.title': '実施',
  'corporateAutomotive.flow.step3.desc': '出張または来校にて研修を実施します。出張型では実際のブランド体験施設や会場で訓練します。',
  'corporateAutomotive.flow.step4.title': '実施後レポート',
  'corporateAutomotive.flow.step4.desc': '研修の総括と改善提案をまとめたレポートをお届けします。',

  // ContactForm
  'corporateAutomotive.contact.label': 'CONTACT',
  'corporateAutomotive.contact.title': 'お問い合わせ',
  'corporateAutomotive.contact.titleEn': 'Inquiry Form',
  'corporateAutomotive.contact.lead': '以下のフォームに必要事項をご入力のうえ、送信ください。',
  'corporateAutomotive.contact.phoneText': 'フォームのほか、お電話',
  'corporateAutomotive.contact.phoneOr': 'またはメール',
  'corporateAutomotive.contact.phoneAccept': 'でも承ります。',
  'corporateAutomotive.contact.hours': '受付時間: 平日 10:00〜17:00',
  'corporateAutomotive.contact.company': '会社名',
  'corporateAutomotive.contact.department': '部署・役職',
  'corporateAutomotive.contact.name': 'ご担当者名',
  'corporateAutomotive.contact.nameRequired': '必須',
  'corporateAutomotive.contact.namePlaceholder': '例: 執事 太郎',
  'corporateAutomotive.contact.nameError': 'ご担当者名は必須です',
  'corporateAutomotive.contact.email': 'メールアドレス',
  'corporateAutomotive.contact.emailRequired': '必須',
  'corporateAutomotive.contact.emailPlaceholder': '例: taro@example.com',
  'corporateAutomotive.contact.emailError': 'メールアドレスは必須です',
  'corporateAutomotive.contact.emailInvalidError': '有効なメールアドレスを入力してください',
  'corporateAutomotive.contact.phone': '電話番号',
  'corporateAutomotive.contact.phoneRequired': '必須',
  'corporateAutomotive.contact.phonePlaceholder': '例: 090-1234-5678',
  'corporateAutomotive.contact.phoneError': '電話番号は必須です',
  'corporateAutomotive.contact.category': '業態・カテゴリ',
  'corporateAutomotive.contact.categoryRequired': '必須',
  'corporateAutomotive.contact.categoryError': '業態をお選びください',
  'corporateAutomotive.contact.format': '希望形式',
  'corporateAutomotive.contact.participants': '想定人数',
  'corporateAutomotive.contact.participantsPlaceholder': '例: 15名',
  'corporateAutomotive.contact.timeline': '検討時期',
  'corporateAutomotive.contact.timelinePlaceholder': '例: 来月、今期中、未定',
  'corporateAutomotive.contact.message': 'ご相談内容（任意）',
  'corporateAutomotive.contact.messagePlaceholder': '研修の目的やご要望、ご不明な点など、自由にご記入ください。',
  'corporateAutomotive.contact.messageMax': '500文字以内で入力してください',
  'corporateAutomotive.contact.submitError': '送信中にエラーが発生しました。お手数ですが再度お試しいただくか、お電話にてお問い合わせください。',
  'corporateAutomotive.contact.submitting': '送信中...',
  'corporateAutomotive.contact.submit': 'この内容で送信する',
  'corporateAutomotive.contact.companyPlaceholder': '例: 株式会社〇〇',
  'corporateAutomotive.contact.departmentPlaceholder': '例: ブランド推進部',
  'corporateAutomotive.contact.catOpt0': '選択してください',
  'corporateAutomotive.contact.catOpt1': '完成車メーカー',
  'corporateAutomotive.contact.catOpt2': 'インポーター',
  'corporateAutomotive.contact.catOpt3': 'モビリティ',
  'corporateAutomotive.contact.catOpt4': '販売店本部',
  'corporateAutomotive.contact.catOpt5': 'その他',
  'corporateAutomotive.contact.fmtOpt0': '選択してください',
  'corporateAutomotive.contact.fmtOpt1': '出張',
  'corporateAutomotive.contact.fmtOpt2': '来校',
  'corporateAutomotive.contact.fmtOpt3': '未定',

  // FAQSection
  'corporateAutomotive.faq.label': 'FAQ',
  'corporateAutomotive.faq.title': 'よくあるご質問',
  'corporateAutomotive.faq.titleEn': 'Frequently Asked Questions',
  'corporateAutomotive.faq.note': 'その他のご質問はフォームよりお寄せください',
  'corporateAutomotive.faq.0.q': '執事の資格が取れますか？',
  'corporateAutomotive.faq.0.a': 'いいえ。執事の接遇スキルに基づくビジネスマナー研修で、資格付与はありません。受講証（参加証明）を発行できます。',
  'corporateAutomotive.faq.1.q': 'イベント直前でも実施できますか？',
  'corporateAutomotive.faq.1.a': 'はい。発表会・試乗会の日程に合わせた集中実施と通し稽古が可能です。',
  'corporateAutomotive.faq.2.q': '料金はいくらですか？',
  'corporateAutomotive.faq.2.a': '半日220,000円、1日330,000円（いずれも税込）からです。出張時の交通費・宿泊費は実費を別途申し受けます。',

  // CTASection
  'corporateAutomotive.cta.label': 'GET STARTED',
  'corporateAutomotive.cta.title': 'まずはお気軽にご相談ください',
  'corporateAutomotive.cta.lead': 'イベント前の集中実施にも対応します。まずは施設の規模とイベント予定をお聞かせください。',
  'corporateAutomotive.cta.sub': '貴社のブランド体験施設の規模や課題をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateAutomotive.cta.inquiry': '研修について問い合わせる',
  'corporateAutomotive.cta.courses': '個人向けコースを見る',
  'corporateAutomotive.cta.desc': '貴社のブランド体験施設の規模や課題をお聞かせいただければ、最適な研修プランを無料でご提案いたします。',
  'corporateAutomotive.cta.note': 'イベント前の集中実施にも対応します。まずは施設の規模とイベント予定をお聞かせください。',
  'corporateAutomotive.cta.online': 'オンラインでのご相談・お打ち合わせにも対応しております。',
  'corporateAutomotive.cta.primary': '研修について問い合わせる',
  'corporateAutomotive.cta.secondary': '個人向けコースを見る',

  // RelatedPages
  'corporateAutomotive.related.label': 'OTHER INDUSTRIES',
  'corporateAutomotive.related.title': '他の業種向けプログラム',
  'corporateAutomotive.related.titleEn': 'Training for Other Industries',
  'corporateAutomotive.related.viewLink': '詳しく見る',
  'corporateAutomotive.related.corporateBack': '法人研修総合ページへ戻る',
  'corporateAutomotive.related.coursesLink': '個人向けコース（執事養成課程）を見る',
  'corporateAutomotive.related.viewMore': '詳しく見る',
  'corporateAutomotive.related.backToCorporate': '法人研修総合ページへ戻る',
  'corporateAutomotive.related.0.title': 'ホテル・旅館',
  'corporateAutomotive.related.0.desc': '開業前研修からバトラーサービスの型まで',
  'corporateAutomotive.related.1.title': 'ハイヤー・送迎',
  'corporateAutomotive.related.1.desc': '乗降の所作と車内の気配りを磨く',
  'corporateAutomotive.related.2.title': '高級レジデンス',
  'corporateAutomotive.related.2.desc': 'コンシェルジュ・フロントの接遇品質を統一',
  'corporateAutomotive.related.3.title': 'ラグジュアリー営業',
  'corporateAutomotive.related.3.desc': '高級車・宝飾・不動産の商談体験を設計',
  'corporateAutomotive.related.4.title': '百貨店外商・高級小売',
  'corporateAutomotive.related.4.desc': 'お得意様対応と訪問の作法',

  // page.tsx
  'corporateAutomotive.page.lastUpdated': '最終更新: 2026年6月13日',
};

export default corporateAutomotive;
